// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from '../../shared/state/search-filters';
import SearchResults, {getDefaultState as getSearchResultsDefaultState} from './search-results';
import t from 'tcomb';

const PipSearch = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    filteredSearchResults: SearchResults,
    hasSearchResults: t.Boolean,
    isValidDealer: t.Boolean,
    searchByType: t.String,
    searchFilters: SearchFilters,
    searchResults: SearchResults
}, 'PipSearch');

export const getDefaultState = () =>
    new PipSearch({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        filteredSearchResults: getSearchResultsDefaultState(),
        hasSearchResults: false,
        isValidDealer: true,
        searchByType: 'PIP',
        searchFilters: getSearchFiltersDefaultState(),
        searchResults: getSearchResultsDefaultState()
    });

export default PipSearch;



// WEBPACK FOOTER //
// ./src/pip/pip-search/state/index.js